export function tabButtonId(baseId: string, tab: string): string {
  return `${baseId}-tab-${tab}`;
}

export function tabPanelId(baseId: string): string {
  return `${baseId}-panel`;
}
